import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getOrganizedUnitsOrganizedUnitSaleOperation from '../../services/organizedUnit/getOrganizedUnitsAll'

export function * fetchOrganizedUnitsAll () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const organizedUnitsAllCombo = yield call(getOrganizedUnitsOrganizedUnitSaleOperation, auth.token)
    yield put(fetchCombosSuccess({ organizedUnitsAllCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }

    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchOrganizedUnitsAll () {
  yield takeLatest(combosActionTypes.FETCH_ORGANIZED_UNITS_ALL, fetchOrganizedUnitsAll)
}
